<template>
  <div class="news-and-footer">
    <div class="page_content">
 <h3>【Important】Notice of Service Interruption and Restoration Due to Server Maintenance</h3>
<br>

<p>Dear Valued Customers,</p>

<p>
  Thank you for your continued support of Scandinavia Service Co., Ltd.
</p>

<p>
  Starting at approximately 10:00 PM on October 21, 2026 (Wednesday),
  our website became temporarily inaccessible due to system maintenance
  addressing PHP security vulnerabilities.
  The issue has now been resolved, and our website is operating normally.
</p>

<p>
  We sincerely apologize for any inconvenience or concern
  this interruption may have caused.
</p>


      <footer2></footer2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'news251226',
  props: {
    largescreen: {
      type: Boolean
    }
  },
  components: {
    footer2: () => import('../components/Footer2.vue'),
  },
}
</script>

<style lang="scss" scoped>
.news-and-footer {
  margin-top: 80px;
}

@media (max-width: 600px) {
  .news-and-footer {
    margin-top: 30px;
  }
}
</style>